import React from 'react'
import { Link } from 'react-router-dom'
import { Tooltip } from '@unbounded/unbounded-components'
import { OrganizationsListItemFragment } from '~api/fragments/OrganizationsListItem.generated'
import Tile from '~components/Tile'
import Image from '~components/Image'
import Paths from '~routes/paths'

interface ComponentProps {
  organization: OrganizationsListItemFragment
}

const OrganizationsListItem: React.FC<ComponentProps> = ({ organization }) => {
  const { name, description, logo, slug } = organization

  return (
    <Tile.Container $isLink={true} as={Link} to={`${Paths.organizations}/${slug}`}>
      <Tooltip content={name}>
        <Tile.Header>
          <Tile.ImageContainer isBright={logo?.isBright}>
            <Image src={logo?.url} alt={name} />
          </Tile.ImageContainer>

          <Tile.Section>
            <Tile.Title>{name}</Tile.Title>
          </Tile.Section>
        </Tile.Header>
      </Tooltip>

      <Tile.Section>
        <Tile.Description>{description || 'No description yet'}</Tile.Description>
      </Tile.Section>
    </Tile.Container>
  )
}

export default OrganizationsListItem
